import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class ConsoleLogFunction extends AbstractBlock {
  constructor() {
    super('console_log_function', t.to('コンソールに表示する', 'console_show'));
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setMoreColor(block);
    ShapeSettings.setElementShape(block);

    // フィールド
    const arg = new Blockly.FieldTextInput('message');

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('コンソールに表示する', 'console_show'))
      .appendField(arg, 'arg');
  }

  /**
   * 動的ブロックは、VirtualDomで評価された時にHTMLとして書き出されないので、JSコードを書き出す
   */
  generateJavaScriptCode(block: BlockType): string {
    const arg = CodeSetting.getFieldValue(block, 'arg');
    const str = `console.log(\`${arg}\`);`;
    return str;
  }

  codeGenerateCore(block: BlockType): string {
    return '';
  }
}
